import _extends from "@babel/runtime/helpers/extends";
import _orderBy from "lodash/orderBy";
import React from 'react';
import { observer } from 'mobx-react';
import { Field, Select } from 'core/form';
import storeLoader from 'app/stores/storeLoader';
const BoardSelector = storeLoader('$boards')(observer(({
  $boards,
  loading,
  fill = true,
  large = false,
  placeholder = 'Select a board...',
  ...rest
}) => {
  if (loading || !$boards) {
    return null;
  }
  const store = $boards;
  const boards = store.collection.get().filter(board => board.get('config')?.isDashboard && board.canEdit && !board.isNew);
  const sorted = _orderBy(boards, [b => b.get('share_level'), b => b.name], ['asc', 'asc']);
  const options = sorted.map(board => ({
    value: String(board.id),
    label: board.name,
    filterLabel: board.name
  }));
  return /*#__PURE__*/React.createElement(Field, _extends({}, rest, {
    options: options,
    large: large
  }), /*#__PURE__*/React.createElement(Select, {
    showFilter: true,
    fill: fill,
    placeholder: placeholder
  }));
}));
export default BoardSelector;